import { createRequestTypes } from 'common/websocket-redux';

export const GET_MAPLE_USER = createRequestTypes(
  'employer-experience/maple-user/GET_MAPLE_USER',
);

export const getMapleUser = userId => GET_MAPLE_USER.request({ userId });
